import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { GButton } from "../parts/ui";
import { color } from "../theme/tokens";

// GToast action ("Undo"): orange text on the black toast (6.2:1), same look
// as App's default "Dismiss" action. Tokens are read directly because toasts
// may render outside our ThemeProvider's custom keys.
const ToastAction = withStyles({
  root: {
    "&&": {
      color: color.brand,
      fontWeight: 700,
      "&:hover": { backgroundColor: "rgba(255,255,255,.08)" }
    }
  }
})(({ classes, onClick, children }) => (
  <GButton variant="ghost" size="sm" className={classes.root} onClick={onClick}>
    {children}
  </GButton>
));

// Toast with an Undo action: showUndoToast(this.props, "Added Farm eggs", fn)
// `props` must come from a withSnackbar-wrapped component.
export const showUndoToast = (
  { enqueueSnackbar, closeSnackbar },
  message,
  onUndo
) => {
  if (typeof enqueueSnackbar !== "function") return;
  enqueueSnackbar(message, {
    variant: "info",
    action: key => (
      <ToastAction
        onClick={() => {
          onUndo();
          if (typeof closeSnackbar === "function") closeSnackbar(key);
        }}
      >
        Undo
      </ToastAction>
    )
  });
};
